import http, { endpoints } from 'api/http';

//external
export const AWS_ADDRESS_ENDPOINT = '/adresser/autocomplete';

export const ENDPOINT_VERSION_V2 = '/api/v2';
export const ENDPOINT_VERSION_V3 = '/api/v3';

//General
export const datahubAxiosClient = http.createClient(`${endpoints.datahub}`);

//User
export const MAIN_USER_ENDPOINT = `/Authentication/user`;
export const SEARCH_USER_ENDPOINT = `/User/by-branchId`;

//Branch
export const BRANCH_ENDPOINT = `/branch`;
export const BRANCHES_ENDPOINT = `/branches`;
export const BRANCH_SEARCH_ENDPOINT = `${BRANCH_ENDPOINT}/search`;
export const BRANCH_SEARCH_V2_ENDPOINT = `${ENDPOINT_VERSION_V2}${BRANCHES_ENDPOINT}/search`;
export const BRANCH_CHECK_ORDER_CREATION_ENDPOINT = `${BRANCH_ENDPOINT}/ordercreationblacklistings`;
export const BRANCH_V2_ENDPOINT = `${ENDPOINT_VERSION_V2}${BRANCHES_ENDPOINT}`;

//CASES
export const CASES_ENDPOINT = `/Cases`;
export const CASES_V2_ENDPOINT = `${ENDPOINT_VERSION_V2}${CASES_ENDPOINT}`;
export const CASES_V3_ENDPOINT = `${ENDPOINT_VERSION_V3}${CASES_ENDPOINT}`;
export const CASE_GET_FILTERS_ENDPOINT = `${CASES_ENDPOINT}/search/filters`;
export const CASES_SEARCH_ENDPOINT = `${CASES_ENDPOINT}/search`;
export const CASE_UPSERT_ENDPOINT = `${CASES_ENDPOINT}/upsert/webshop`;
export const CASES_SEARCH_FILTER_PARAMS_ENDPOINT = `${CASES_SEARCH_ENDPOINT}/filters`;
export const CASES_SEARCH_V2_ENDPOINT = `${CASES_V2_ENDPOINT}/search`;
export const CASES_SEARCH_V3_ENDPOINT = `${CASES_V3_ENDPOINT}/search`;
export const CASES_V2_NEWS_CASE_ENDPOINT = `${CASES_V2_ENDPOINT}/new/search`;
export const CASES_V2_EXISTING_CASE_ENDPOINT = `${CASES_V2_ENDPOINT}/existing/search`;

//Orders
export const ORDERS_ENDPOINT_V1 = '/orders';
export const ORDERS_ENDPOINT = `${ENDPOINT_VERSION_V2}/orders`;
export const ORDER_TASKS_ENDPOINT = `${ENDPOINT_VERSION_V2}/ordertasks`;
export const ORDER_GET_TOTAL_TASKS_ENDPOINT = `${ORDER_TASKS_ENDPOINT}/total`;
export const ORDER_COUNT_OPEN_TASKS_ENDPOINT = `${ORDERS_ENDPOINT}/statistic/count`;
export const ORDER_GET_SOCIAL_MEDIA_OPTIONS_ENDPOINT = `${ORDERS_ENDPOINT_V1}/tasks/sometypes`;
export const ORDER_WITH_TASKS_ENDPOINT = `${ORDERS_ENDPOINT_V1}/tasks`;
export const ORDER_CREATE_NEW_ORDER_ENDPOINT_V2 = `${ENDPOINT_VERSION_V2}/orders`;

//Booking
export const BOOKING_ENDPOINT = '/bookings';

//products
export const PACKAGES_ENDPOINT = `${ENDPOINT_VERSION_V2}/packages/search`;

//Material
export const ASSETS_ENDPOINT = `/assets`;
export const DOWNLOAD_MATERIAL_ENDPOINT = `${ASSETS_ENDPOINT}/download-link/ewarp-materials/email`;
export const REMOVE_BATCH_MATERIAL_ENDPOINT = `${ASSETS_ENDPOINT}/delete-materials-and-assets`;
//texts
export const TEXTS_ENDPOINT = `/texts`;

// Statistic
export const STATISTIC_ENDPOINT = `${ENDPOINT_VERSION_V2}/statistic/advertising`;

// Users
export const INVITE_USER_ENDPOINT = `/User/Invitation`;

// S3
export const S3_ENDPOINT = `/webshop/s3/endpoint`;

//Static asset
export const STATIC_ASSET_ENDPOINT = `${ENDPOINT_VERSION_V2}/static-assets`;

//sales product
export const SALES_PRODUCT_ENDPOINT = `${ENDPOINT_VERSION_V2}/sale-products`;

//Dynamic
export const ENDPOINT_DETAILS = {
  //User
  searchUserByBranchId: (branchId: string) => `${SEARCH_USER_ENDPOINT}/${branchId}`,
  getActiveUsersByBranchId: (branchId: string) => `${SEARCH_USER_ENDPOINT}/${branchId}/active`,
  getPendingUsersByBranchId: (branchId: string) => `${INVITE_USER_ENDPOINT}/branch/${branchId}`,
  updateUser: (userId: string) => `/User/id/${userId}`,
  resendInvitation: (userId: string) => `${INVITE_USER_ENDPOINT}/${userId}/resend`,

  //Orders
  getOpenTasks: (status: string) => `${ORDER_COUNT_OPEN_TASKS_ENDPOINT}?status=${status}`,
  getOrderTasks: (orderId: string) => `${ORDERS_ENDPOINT_V1}/${orderId}/tasks`,
  getBookingInfo: (orderId: string) => `${ORDERS_ENDPOINT_V1}/${orderId}/booking-info`,
  getOrderLines: (orderId: string) => `${ORDERS_ENDPOINT_V1}/${orderId}/orderlines`,
  addOrderLine: (orderId: string) => `${ORDERS_ENDPOINT_V1}/${orderId}/orderlines/add`,
  orderWatchers: (orderId: string) => `${ORDERS_ENDPOINT_V1}/${orderId}/watchers`,
  updateResponsibleAgent: (orderId: string) => `${ORDERS_ENDPOINT_V1}/${orderId}/responsible`,
  getContactPersonTypes: () => `${ORDERS_ENDPOINT}/contact-person-types`,
  //Booking
  getProposalByBookingId: (bookingId: string) => `${BOOKING_ENDPOINT}/${bookingId}/proposals`,

  //products
  additionalProduct: (branchId: string) => `${BRANCHES_ENDPOINT}/${branchId}/products/alacarte`,
  getProductListByBranchId: (branchId: string) => `${BRANCHES_ENDPOINT}/${branchId}/products/list`,

  //tasks
  sendEmailForInterviewTaskText: (taskId: string) => `${ORDER_WITH_TASKS_ENDPOINT}/${taskId}/interviews/send`,
  addNoteForTaskText: (taskId: string) => `${ORDER_WITH_TASKS_ENDPOINT}/${taskId}/notes/add`,
  completeTask: (taskId: string) => `${ORDER_WITH_TASKS_ENDPOINT}/${taskId}/complete`,
  completeSomeSlideShowTask: (taskId: string) => `${ORDER_WITH_TASKS_ENDPOINT}/${taskId}/complete/some`,
  getUploadedFiles: (orderLineId: string) => `${ORDERS_ENDPOINT_V1}/orderlines/${orderLineId}/taskfileuploads`,
  removeUploadedFile: (orderLineId: string) => `${ORDERS_ENDPOINT_V1}/orderlines/taskfileuploads/${orderLineId}`,
  upload: (orderLineId: string) => `${ORDERS_ENDPOINT_V1}/orderlines/${orderLineId}/taskfileuploads/add`,
  getTextSection: (orderLineId: string) => `${ORDER_WITH_TASKS_ENDPOINT}/texts/${orderLineId}/textsections`,
  saveCopyWriteTexts: () => `${ORDER_WITH_TASKS_ENDPOINT}/texts/complete`,
  submitFeedback: () => `${ORDERS_ENDPOINT_V1}/rating/w2`,
  updateBookingType: (taskId: string, bookingId: string) =>
    `${ORDER_WITH_TASKS_ENDPOINT}/${taskId}/updateType?bookingId=${bookingId}`,
  confirmBookingPhotographer: (bookingId: string) => `${BOOKING_ENDPOINT}/${bookingId}/proposals/confirm`,
  thirdPartyBooking: () => `${BOOKING_ENDPOINT}/third-party-link`,
  markDonePartially: (taskId: string) => `${ORDER_WITH_TASKS_ENDPOINT}/${taskId}/partially`,
  openTasksByCaseId: (caseId: string) => `${CASES_ENDPOINT}/${caseId}/tasks/open`,
  getNumberOfTasks: () => `${ENDPOINT_VERSION_V2}/task-statistics/count`,
  sealUploadedFiles: (orderLineId: string) => `${ORDERS_ENDPOINT_V1}/orderlines/${orderLineId}/materials/add`,
  getInputTextSlideShow: () => `${ORDERS_ENDPOINT_V1}/tasks/texts/inputforspeakslideshow`,
  sendQuestionnaireAITextEmail: (taskId: string) => `${ORDER_WITH_TASKS_ENDPOINT}/${taskId}/questionnaire/send`,
  getTaskDetails: (taskId: string) => `${ORDER_WITH_TASKS_ENDPOINT}/${taskId}/details`,
  //cases
  getAssets: (caseId: string) => `${CASES_ENDPOINT}/${caseId}/assets`,
  copyAssets: (caseId: string) => `${CASES_ENDPOINT}/${caseId}/assets/copy`,
  getCase: (caseId: string) => `${CASES_ENDPOINT}/${caseId}`,
  getCollagePrice: (caseId: string) => `${CASES_ENDPOINT}/${caseId}/assets/collage/pricing`,
  ordersInCase: (caseId: string) => `${CASES_ENDPOINT}/${caseId}/orders`,
  caseDetail: (caseId: string) => `${CASES_ENDPOINT}/${caseId}`,
  archiveMaterial: (caseId: string) => `${CASES_ENDPOINT}/${caseId}/assets/archive`,
  getAssetOptions: (caseId: string) => `${CASES_ENDPOINT}/${caseId}/assets/allowednames`,
  updateAssets: (caseId: string) => `${CASES_ENDPOINT}/${caseId}/assets/sortorder`,
  recreateMaterials: (caseId: string) => `${CASES_ENDPOINT}/${caseId}/assets/restore`,
  submitCollage: (caseId: string) => `${CASES_ENDPOINT}/${caseId}/assets/collage`,
  linkMaterials: (caseId: string) => `${CASES_ENDPOINT}/${caseId}/assets/links`,
  documentMaterials: (caseId: string) => `${CASES_ENDPOINT}/${caseId}/assets/documents`,
  getTextSections: (caseId: string) => `${CASES_ENDPOINT}/${caseId}/texts/current`,
  getAssetDocumentsByCaseId: (caseId: string) => `${CASES_ENDPOINT}/${caseId}/assets/documents`,
  getTextGroups: () => `${TEXTS_ENDPOINT}/getalltextsections`,
  getTextDocumentHistory: (caseId: string, fieldName: string) => `${CASES_ENDPOINT}/${caseId}/texts/${fieldName}`,
  createTextDocument: (caseId: string) => `${ENDPOINT_VERSION_V2}${CASES_ENDPOINT}/${caseId}/text-documents`,
  caseAddress: (caseId: string) => `${CASES_ENDPOINT}/${caseId}/address`,
  getNumberOfCases: () => `${ENDPOINT_VERSION_V2}/case-statistics/count`,
  completeMultipleTasks: (taskId: string, apiType: string) =>
    `${ORDER_WITH_TASKS_ENDPOINT}/${taskId}/complete/${apiType}`,
  virtualStaging: () => `${ORDERS_ENDPOINT_V1}/tasks/virtual-staging`,
  completeVirtualStaging: (taskId: string) => `${ORDERS_ENDPOINT_V1}/tasks/${taskId}/complete/virtual-staging`,
  getCurrentChain: () => `${ENDPOINT_VERSION_V2}/chains/me`,

  //branch
  branchProfile: (branchId: string) => `${BRANCH_V2_ENDPOINT}/${branchId}/profile`,
  branchById: (branchId: string) => `${BRANCH_V2_ENDPOINT}/${branchId}`,
  createBranchSocialMedia: (branchId: string) => `${BRANCH_V2_ENDPOINT}/${branchId}/social-media`,
  updateBranchSocialMedia: (socialMediaId: string) => `${BRANCH_V2_ENDPOINT}/social-media/${socialMediaId}`,

  //news
  getNews: (language: string, numberOfNews: number = 3) => `/news/language/${language}?numberOfNews=${numberOfNews}`,

  //addresses
  getAddresses: (branchId: string) => `${ENDPOINT_VERSION_V2}${BRANCHES_ENDPOINT}/${branchId}/addresses`,

  //fees
  getFees: (branchId: string) => `${ENDPOINT_VERSION_V2}${BRANCHES_ENDPOINT}/${branchId}/fees`,
  //property types
  getPropertyTypes: () => `${ENDPOINT_VERSION_V2}/property-types`,
};
